import { createSelector } from 'reselect';

// import { isLoggedIn, isEmpty } from '../../../common/Helpers';
// import { getDeliveryDay } from '../../../common/Helpers/dates';

export const selectState = (state) => state || {};
export const selectCart = createSelector(selectState, (state) => state?.cartDetails || {});
export const selectStateCache = createSelector(selectCart, (cart) => cart.stateCache || Date.now());

export const selectCheckout = (state) => state?.checkout || {};
// export const selectStateCache = createSelector(selectCheckout, (checkout) => checkout.stateCache || Date.now());

export const selectCartHeader = createSelector(selectCart, (cart) => cart?.cartHeader || {});
export const orderStatus = createSelector(selectCart, (cart) => cart?.cartHeader?.status);
export const selectOrderDetails = createSelector(selectCart, (cart) => cart?.orderDetails || {});

// export const selectPlans = createSelector(selectState, (state) => state?.plans || null);
// export const selectPlanProductRef = createSelector(selectState, (state) => state?.planProductRefData || null);
